export const UPSERT_CUSTOMER_IMPORT_FILE_STATUS = "UPSERT_CUSTOMER_IMPORT_FILE_STATUS";

export interface CustomerImportFileStatusUpsertedAction {
    type: typeof UPSERT_CUSTOMER_IMPORT_FILE_STATUS;
}

export type CustomerImportFileStatusActions = CustomerImportFileStatusUpsertedAction;
